<template>
  <div class="d-flex align-items-center min-vh-100">
    <CContainer fluid>
      <CRow class="justify-content-center">
        <CCol md="6" lg="6">
          <CRow>
            <img
              src="@/assets/images/Herd1.png"
              style="width: 100%; height: 100%"
            />

            <CCol style="padding-top: 25px">
              <h2>&#8226; Animal Lifecycle Management</h2>
              <h2>&#8226; Farm Productivity</h2>
              <h2>&#8226; Veterinary and Health Data</h2>
            </CCol>
          </CRow>
        </CCol>
        <CCol md="5" lg="5">
          <!-- <CCardGroup> -->
          <CCard class="p-4 vertical-center" style="padding: 0 !important">
            <CCardBody>
              <CForm>
                <h1>Sign up</h1>
                <br />

                <CRow>
                  <CCol sm="6">
                    <CInput
                      type="text"
                      label="First Name *"
                      placeholder="Enter your First name"
                      v-model="user.FirstName"
                      invalid-feedback="Please provide a required input."
                    />
                  </CCol>
                  <CCol sm="6">
                    <CInput
                      label="Last Name "
                      placeholder="Enter your Last name"
                      v-model="user.LastName"
                      invalid-feedback="Please provide a required input."
                    />
                  </CCol>
                </CRow>
                <CRow>
                  <CCol sm="6">
                    <CInput
                      label="Password *"
                      type="password"
                      placeholder=" Password"
                      v-model="user.Password"
                      invalid-feedback="Please provide a required input."
                    />
                  </CCol>
                  <CCol sm="6">
                    <CInput
                      label="Confirm Password *"
                      type="password"
                      placeholder="Confirm Password"
                      v-model="user.ConfirmPassword"
                      invalid-feedback="Please provide a required input."
                    />
                  </CCol>
                </CRow>
                <CRow>
                  <CCol sm="6">
                    <CInput
                      label="Email *"
                      placeholder="Enter your Email"
                      v-model="user.Email"
                      invalid-feedback="Please provide a required input."
                    />
                  </CCol>
                </CRow>
                <CDropdownDivider />

                <CRow>
                  <CCol sm="6">
                    <CInput
                      label="Farm Name *"
                      placeholder=" Enter your Farm Name"
                      v-model="user.FarmName"
                      invalid-feedback="Please provide a required input."
                    />
                  </CCol>
                  <CCol sm="6">
                    <span style="font-size: 14px">Country *</span>
                    <br />

                    <Vselect
                      style="padding-top: 7px; height: 36px"
                      v-model="user.Country"
                      :options="countryArr"
                      searchable
                    />
                  </CCol>
                </CRow>
                <CRow>
                  <CCol sm="6">
                    <CInput
                      label="Animal Count"
                      placeholder="Enter Farm Animal Count"
                      v-model="user.AnimalCount"
                    />
                  </CCol>
                  <CCol sm="6">
                    <CInput
                      type="number"
                      label="Mobile"
                      placeholder="Enter your mobile"
                      v-model="user.Mobile"
                    />
                  </CCol>
                </CRow>
                <CRow>
                  <CCol sm="9">
                    <CInputCheckbox
                      id="checkbox-1"
                      v-model="status"
                      name="checkbox-1"
                      value="accepted"
                      unchecked-value="not_accepted"
                    ></CInputCheckbox>
                    <br />
                    <span>I accept terms and condition</span>
                  </CCol>
                </CRow>

                <CRow v-if="errMsg">
                  <CCol col="12">
                    <CAlert color="danger" closeButton :show.sync="alert1">{{
                      errMsg
                    }}</CAlert>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol col="6" class="text-left">
                    <CButton color="primary" class="px-4" @click="submit()"
                      >Sign Up</CButton
                    >
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>
<script src="https://cdn.jsdelivr.net/gh/manuelmhtr/countries-and-timezones@latest/dist/index.js" type="text/javascript"></script>

<script>
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import { vuecountryselect } from "vue-country-select";
import VueCountryCode from "vue-country-code";
import { validationMixin } from "vuelidate";
import { APIService } from "@/apiservice.js";
import { Vselect } from "@/components";

import {
  required,
  minLength,
  email,
  sameAs,
  helpers,
} from "vuelidate/lib/validators";

export default {
  components: {
    VuePhoneNumberInput,
    vuecountryselect,
    VueCountryCode,
    Vselect,
  },
  name: "Login",
  data() {
    return {
      result: null,
      countries: undefined,
      user: {
        FirstName: "",
        LastName: "",
        Address: "",
        Mobile: "",
        Email: "",
        Password: "",
        ConfirmPassword: "",
        FarmName: "",
        AnimalCount: "",
        submitted: false,
        msg: "fdr",
      },
      status: "",
      alert1: true,
      option: "",
      firstVar: true,
      lastVar: true,
      passwordVar: true,
      mobileVar: true,
      farmVar: true,
      countryVar: true,
      emailVar: true,
      errMsg: null,
      country: "",
      region: "",
      countryArr: [],
    };
  },
  computed: {
    isValid() {
      return !this.$v.user.$invalid;
    },
  },
  watch: {
    "user.FirstName"() {
      if (this.user.FirstName) {
        this.errMsg = "";
        // this.firstVar = true;
      } else {
        this.errMsg = "Please Enter FirstName";
      }
    },
    "user.Email"() {
      if (this.user.Email) {
        this.errMsg = "";
        // this.emailVar = true;
      } else {
        this.errMsg = "Please Enter Email";
      }
    },
    "user.password"() {
      if (this.user.Password) {
        this.errMsg = "";
      } else {
        this.errMsg = "Please Enter Password";
      }
    },
    "user.ConfirmPassword"() {
      if (this.user.ConfirmPassword) {
        this.errMsg = "";
      } else {
        this.errMsg = "Please Enter Confirm Password";
      }
    },
    "user.Mobile"() {
      if (this.user.Mobile) {
        this.mobileVar = true;
        // this.errMsg = "";
      }
    },
    "user.FarmName"() {
      if (this.user.FarmName) {
        this.errMsg = "";
      } else {
        this.errMsg = "Please Enter Farm Name";
      }
    },
  },
  mixins: [validationMixin],
  validations: {
    user: {
      FirstName: {
        required,
        minLength: minLength(3),
      },
      LastName: {
        required,
        minLength: minLength(2),
      },
      Email: {
        required,
        email,
      },
      Password: {
        required,
        minLength: minLength(8),
        strongPass: helpers.regex(
          "strongPass",
          /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/
        ),
      },
      ConfirmPassword: {
        required,
        sameAsPassword: sameAs("Password"),
      },
      FarmName: {
        required,
        minLength: minLength(5),
      },
    },
  },

  methods: {
    getCountry() {
      APIService.getAllCountry().then((res) => {
        if (res.status == 200) {
          for (let i in res.data) {
            this.countryArr.push(res.data[i].name);
          }
        }
      });
    },
    notifyMsg(msg, type) {
      this.$notify({
        timeout: 1000,
        message: msg,
        icon: "add_alert",
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
      });
    },
    fetchData() {
      var self = this;
      self.$https.get("https://restcountries.eu/rest/v2/all").then(
        function (res) {
          self.countries = res.body;
        },
        function (err) {}
      );
    },
    forgotpassword() {
      this.$router.push({
        path: "/forgot",
      });
    },

    submit() {
      let self = this;
      // this.errMsg = null;
      this.err = null;
      let data = {
        firstName: self.user.FirstName,
        lastName: self.user.LastName,
        address: self.user.Address,
        phoneNumber: self.user.Mobile,
        email: self.user.Email,
        password: self.user.Password,
        farmName: self.user.FarmName,
        animalCount: self.user.AnimalCount,
        country: self.user.Country,
      };

      const { dispatch } = self.$store;
      if (
        this.user.FirstName &&
        this.user.Country &&
        this.user.Password &&
        this.user.Email &&
        this.user.FarmName &&
        !this.errMsg
      ) {
        if (this.user.Password == this.user.ConfirmPassword) {
          APIService.saveUser(data).then((res) => {
            if (res.status == 200) {
              APIService.saveToken(res);
              self.$router.push({ name: "Dashboard" });

              // swal
              //   .fire({
              //     title: "Success",
              //     text: "Your registration is successfully.",
              //     type: "success",
              //     buttonsStyling: false,
              //     confirmButtonClass: "md-button md-success",
              //   })
              //   .then((result) => {
              // if (result.value) {
              window.location.href = "/";
              // }
              // });
            } else {
              this.errMsg = "This Email already Exists";
            }
          });
        } else {
          this.errMsg = "Please Check Password and ConfirmPassword";
        }
      } else {
        this.errMsg = "Please enter required fields.";
      }

      // APIService.login(data).then(
      //   (res) => {
      //     if (res.status == 200) {
      //       APIService.saveToken(res);
      //       self.$router.push({ name: "Dashboard" });

      //       if (res.data.language && res.data.language == "Arabic") {
      //         self.$router.push({ name: "propertieslist_ar" });
      //       } else {
      //         self.$router.push({ name: "property List3" });
      //       }
      //     } else {
      //       self.errMsg = res.message;
      //       self.user.password = "";
      //       this.errors.clear();
      //       this.$validator.reset();
      //       this.$refs.pass.$el.focus();
      //     }
      //   },
      //   (err) => {
      //     self.errMsg = "Something went wrong. Please try after sometime.";
      //   }
      // );
    },
  },
  created() {
    this.getCountry();
  },
};
</script>
